// removed by extract-text-webpack-plugin
module.exports = {"container":"_3IdtH","visible":"_1hVz_","flexContainer":"_3CAT6","button":"_2w_bZ","smallSpace":"_1txNy","separator":"_34Zyt","input":"_11jhI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/plugins/media-block/media-block-editor.scss
// module id = 768
// module chunks = 3 4 5 6 7